import type { IDesignConfig } from "@/core/types";

export const design = {
  fonts: [
    "https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,400..900;1,400..900&family=Geologica:wght@400..900&display=swap",
  ],
} satisfies IDesignConfig;
